import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'removeItinerary'
})
export class RemoveItineraryPipe implements PipeTransform {

  transform(value: Observable<any[]>): Observable<any[]> {
    return value.pipe(
      map(itineraries => itineraries.filter(itinerary => itinerary.Id !== 10 && itinerary.Id !== 7))
    );
  }

}
